
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import ModalStylePageLayout from '@/components/organisms/layout/ModalStylePageLayout.vue'
import GradeTip from '@/components/organisms/GradeTip.vue'
import SubjectTip from '@/components/organisms/SubjectTip.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import ProblemPassageHistory from '@/components/organisms/ProblemPassageHistory.vue'
import ProblemPassageNext from '@/components/organisms/ProblemPassageNext.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'

/**
 * 単元別大問演習履歴一覧
 */
@Component({
  components: {
    ButtonSubmit,
    ModalStylePageLayout,
    GradeTip,
    SubjectTip,
    LearningProgressTip,
    ProblemPassageHistory,
    ProblemPassageNext,
  },
})
export default class ProblemPassageCurriculumUnit extends Vue {
  /** 単元別問題一覧 */
  @Prop()
  private curriculumUnit!: LearningProblemCurriculumUnit.ProblemPassage

  /** 次の演習問題クリック時のイベント */
  @Prop()
  private eventClickNextProblem!: () => Promise<void>

  /** 履歴問題クリック時のイベント */
  @Prop()
  private eventClickHistoryProblem!: (problemCode: string, level: number) => Promise<void>

  /** 履歴ボタン押下時のイベント */
  @Prop()
  private eventClickHistroyButton!: (id: number) => void

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => Promise<void>

  /**
   * 次問題の線の有無を判定
   *
   * @returns 履歴の表示ありならtrue
   */
  private get showLineNext(): boolean {
    return this.curriculumUnit.problemHistories.length > 0
  }

  /**
   * 履歴問題の線の表示
   *
   * @param index 履歴一覧のインデックス
   * @returns 最後の要素ならfalseで線を消す
   */
  private showLineHistory(index: number): boolean {
    // 履歴がない場合はfalseを返す
    if (this.curriculumUnit.problemHistories.length === 0) {
      return false
    }
    // 対象が履歴一覧で最後の場合、falseを返す
    return index !== this.curriculumUnit.problemHistories.length - 1
  }
}
